<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-xl-4 order-lg-1 order-xl-1" v-permission="'contract.view'">
        <!--begin:: Widgets/Activity-->
        <KTPortlet
                v-bind="{
              title: 'Form',
              // class: 'kt-portlet--fit kt-portlet--skin-solid',
              // headClass: 'kt-portlet__head--noborder kt-portlet__space-x',
              // headSize: 'lg',
              fluidHeight: true,
              // headOverlay: true,
              // headNoBorder: true
            }"
        >
          <template v-slot:body>
            <b-button class="mb-3"  v-if="item.enabled" v-for="item in documents" :key="item.id+item?.user?.email" @click="openForm(item)" variant="outline-primary">{{item.label}}<template v-if="false && item.user"> - {{item.user.email}}</template></b-button>
          </template>
        </KTPortlet>
        <!--end:: Widgets/Activity-->
      </div>
      <div class="col-lg-6 col-xl-4 order-lg-1 order-xl-1" v-permission="'contract.view'">
        <!--begin:: Widgets/Activity-->
        <KTPortlet
                v-bind="{
              title: 'Lista Documenti',
              // class: 'kt-portlet--fit kt-portlet--skin-solid',
              // headClass: 'kt-portlet__head--noborder kt-portlet__space-x',
              // headSize: 'lg',
              fluidHeight: true,
              // headOverlay: true,
              // headNoBorder: true
            }"
        >
          <template v-slot:body>
            <b-button :to="{name:'document-list'}" class="mr-3" variant="outline-primary">Vai alla lista</b-button>
          </template>
        </KTPortlet>
        <!--end:: Widgets/Activity-->
      </div>

      <div class="col-lg-6 col-xl-4 order-lg-1 order-xl-1" v-permission="'contract.log.view'">
        <!--begin:: Widgets/Activity-->
        <KTPortlet
                v-bind="{
              title: 'Registro Documenti',
              // class: 'kt-portlet--fit kt-portlet--skin-solid',
              // headClass: 'kt-portlet__head--noborder kt-portlet__space-x',
              // headSize: 'lg',
              fluidHeight: true,
              // headOverlay: true,
              // headNoBorder: true
            }"
        >
          <template v-slot:body>
            <b-button :to="{name:'document-history'}" class="mr-3 mb-3" variant="outline-primary">Vai allo storico invii</b-button>
            <b-button v-if="featureDraftEnabled" :to="{name:'document-history-drafts'}" class="mr-3 mb-1" variant="outline-primary">Vai alle bozze</b-button>
          </template>
        </KTPortlet>
        <!--end:: Widgets/Activity-->
      </div>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import ApiService from "../../common/api.service";
import { FEATURE_DRAFT_ENABLED } from "@/common/config";
import UserService from "@/common/user.service";
import { filterDocumentsByVisibility } from "../../common/util.service";

export default {
  name: "dashboard",
  components: {
    KTPortlet
  },
  data() {
    return {
      featureDraftEnabled: FEATURE_DRAFT_ENABLED,
      documents: [

      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.reloadList();
  },
  methods: {
    async openForm(item) {
      // Are we impersonating the right user already?
      const current = this.$store.getters.currentUser;

      // item.user is present only for impersonated datasets
      const targetUserId = item.user ? item.user.user_id : current.id;
      // console.log("openForm", item, targetUserId);

      if (targetUserId && current.id !== targetUserId) {
        // if we are currently impersonating a user, we need to stop it first
        if (this.$store.getters.isImpersonating) {
          await this.$store.dispatch("stopImpersonateUser");
        }

        // Swap JWT so subsequent API calls act as target user
        await this.$store.dispatch("startImpersonateUser", targetUserId);
      }

      // Navigate to the form
      this.$router.push({ name: "document-form", params: { id: item.id } });
    },
    async reloadList() {
      const fetchContracts = async (user) => {
        const { data } = await ApiService.get("contracts");
        // add userId to each contract if userId is provided
        if (user) {
          data.rows.forEach(contract => {
            contract.user = user;
          });
        }
        return data.rows;
      };

      /*const resultSets = UserService.hasImpersonations()
          ? await UserService.runForAllImpersonations(fetchContracts)
          : [await fetchContracts()];*/

      const resultSets = [];

      /* 1️⃣ always include the logged-in user */
      resultSets.push(await fetchContracts(this.$store.getters.currentUser));

      /* 2️⃣ append results for each impersonable account, if any */
      if (UserService.hasImpersonations() || this.$store.getters.isImpersonating) {
        const extra = await UserService.runForAllImpersonations(fetchContracts);
        resultSets.push(...extra);           // merge arrays
      }
const allRows = resultSets.flat();

const user = this.$store.getters.currentUser;
const groupIds = user && (user.group_ids || (user.groups ? user.groups.map(g => g.id) : [user.group_id]).filter(Boolean)) || [];
const userId = user && user.id;
const filteredRows = filterDocumentsByVisibility(allRows, userId, groupIds);

this.documents = Array.from(
    filteredRows.reduce((map, contract) => {
        if (!map.has(contract.id)) {
            map.set(contract.id, contract); // Add only the first occurrence
        }
        return map;
    }, new Map()).values()
)
    .reverse()
    .sort((a, b) => {
        const prio = obj => {
            const o = obj.opts ? JSON.parse(obj.opts) : {};
            return o.Priority && o.Priority !== "" ? o.Priority : 10;
        };
        return prio(a) - prio(b);
    });

    }
  },
};
</script>
